import { useSelector } from 'react-redux'

import { ApplicationState } from 'redux/Stores/types'

import {
  selectAll,
  selectAllGrouped,
  selectBenchmarkAttributeOptions,
  selectBreakdownBy,
  selectCommonAttributeOptions,
  selectFetched,
  selectKpiOptionAttributeOptions,
  selectMetricSegmentAttributeOptions,
  selectSegmentBy,
  selectAttributeOption
} from 'redux/selectors/AttributeOptions'
import { KpiOptionObject } from 'types/GlobalKpiOption'
import { TWidget, TWidgetSettings } from 'types/GlobalWidget'

export const useAttributeOptionsFetched = () => {
  return useSelector(selectFetched)
}

export const useAttributeOptions = () => {
  return useSelector(selectAll)
}

export const useGroupedAttributeOptions = () => {
  return useSelector(selectAllGrouped)
}

export const useCommonAttributeOptions = (
  widget: TWidget,
  type: 'segment_attribute' | 'filter_attribute'
) => {
  return useSelector((state: ApplicationState) =>
    selectCommonAttributeOptions(state, widget, type)
  )
}

export const useKpiOptionAttributeOptions = (
  settings: TWidgetSettings,
  kpiOption: KpiOptionObject,
  type: 'breakdown_attribute' | 'filter_attribute'
) => {
  return useSelector((state: ApplicationState) =>
    selectKpiOptionAttributeOptions(state, settings, kpiOption, type)
  )
}

export const useMetricSegmentAttributeOptions = (
  factTableId?: string | null
) => {
  return useSelector((state: ApplicationState) =>
    selectMetricSegmentAttributeOptions(state, factTableId)
  )
}

export const useAttributeOption = (id?: string | null) => {
  return useSelector((state: ApplicationState) =>
    selectAttributeOption(state, id)
  )
}

export const useBenchmarkAttributeOptions = (filterOptions: string[]) => {
  return useSelector((state: ApplicationState) =>
    selectBenchmarkAttributeOptions(state, filterOptions)
  )
}

export const useSegmentBy = (
  settings: TWidgetSettings | null,
  customSegmentBy?: string | null
) => {
  return useSelector((state: ApplicationState) =>
    selectSegmentBy(state, settings, customSegmentBy)
  )
}

export const useBreakdownBy = (kpiOption: KpiOptionObject) => {
  return useSelector((state: ApplicationState) =>
    selectBreakdownBy(state, kpiOption)
  )
}
